module.exports = __webpack_public_path__ + "img/nature-55.40f963c6.jpg";